module.exports = __webpack_public_path__ + "img/inst-15.dc2e2d63.png";